import * as React from 'react';

// Hooks
import { useTranslation } from '@shopee-user/platform';

// Components
import { InputPhone } from '@shopee-user/input';

// Utils
import { loadPhoneLibrary } from '@shopee-user/authentication-utils';

// Types
import { InputLoginByOtpAuthKeyProps } from '@shopee-user/business-customization-types';

export const InputLoginByOtpAuthKey = ({
  pristine,
  errors,
  value,
  active,
  onChange,
  onFocus,
  onBlur,
  clear,
  reset,
}: InputLoginByOtpAuthKeyProps) => {
  const I18n = useTranslation();
  return (
    <InputPhone
      errors={errors}
      value={value}
      active={active}
      placeholder={I18n.t('label_auth_phone_number')}
      showErrorOutline
      showError
      autoFocus
      onChange={e => {
        // preload phone library that is used for validation as soon as user typing in, reasons:
        // 1. for autofocus in captcha to work in iOS, it needs to be immediate, it can't wait for async operation.
        // 2. better UX since the validation will be quicker for user
        if (pristine) {
          void loadPhoneLibrary();
        }
        onChange(e);
      }}
      onFocus={onFocus}
      onBlur={onBlur}
      clear={clear}
      reset={reset}
    />
  );
};
